var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-4":"","pb-5":""}},[_c('app-button',{staticClass:"new-poll",attrs:{"text":"Nuevo"},on:{"click":function($event){_vm.goTo('new-organizational-diagnosis')}}}),_vm._v(" "),_c('surveys-list',{attrs:{"tool-code":_vm.toolCode}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443d51c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizational/page-surveys.vue
// module id = 3403
// module chunks = 65